import { createContext, useContext } from "react";

import {
  AUSTRALIAN_CRIMINAL_OPTION,
  CCRC_LEVEL,
  CRIMINAL_RECORD_VALIDATION,
  US_CRIMINAL_PREFERENCE,
} from "../constants";
import { CriminalRecordTemplateFormValues } from "../types";

export const initialCriminalRecordTemplateValues: CriminalRecordTemplateFormValues =
  {
    name: "",
    lookback_years: CRIMINAL_RECORD_VALIDATION.DEFAULT_LOOKBACK_YEARS,
    check_arguments: {
      umbrella_minimum_address_duration_months:
        CRIMINAL_RECORD_VALIDATION.DEFAULT_DURATION_MONTHS,
      umbrella_address_history_range_months:
        CRIMINAL_RECORD_VALIDATION.DEFAULT_LOOKBACK_YEARS * 12,
      umbrella_apply_residency_rules_to_current_address: true,
      maximum_price: {},
      canadian_criminal_preference: CCRC_LEVEL.BASIC,
    },
    australian_criminal_option: AUSTRALIAN_CRIMINAL_OPTION.AFP,
    us_criminal_preference: US_CRIMINAL_PREFERENCE.NONE,
    us_criminal_checks: {},
  };

export interface CriminalRecordTemplatesContextType {
  criminalRecordTemplate: CriminalRecordTemplateFormValues;
  setCriminalRecordTemplate: (
    criminalRecordTemplate: CriminalRecordTemplateFormValues
  ) => void;
}

export const CriminalRecordTemplatesContext =
  createContext<CriminalRecordTemplatesContextType>({
    criminalRecordTemplate: initialCriminalRecordTemplateValues,
    setCriminalRecordTemplate: (newState: CriminalRecordTemplateFormValues) =>
      newState,
  });

export function useCriminalRecordTemplatesContext() {
  return useContext(CriminalRecordTemplatesContext);
}
